<template>
  <div class="lesson-page">
    <LessonHeader :style="safeTopVar" class="LesonTop" :currentData="data" />
    <div class="loader" v-if="!data">
      {{ $t("lesson.lesson-page.loading") }}
      <!-- <v-progress-circular indeterminate color="primary"></v-progress-circular> -->
      <div
        style="text-align: center; display: flex; justify-content: center; margin: 8px;"
      >
        <SlinkyVue />
      </div>
    </div>
    <div v-if="data" class="centered">
      <div class="lesson-player">
        <div v-if="data.text" style="padding-bottom: 0.5em;">
          {{ data.text }}
        </div>
        <div v-if="lessonAudio">
          <AudioPlayerLesson :audioSrc="lessonAudio" :height="25" :autoPlay="true" />
        </div>
      </div>
      <div v-if="lessonImage">
        <div>
          <img :src="lessonImage" />
        </div>
      </div>
      <div v-if="data.video">
        <div>
          <VideoPlayer :vidSrc="makeLinkEmbaddable(data.video)" />
        </div>
      </div>
      <div style="height: 75px; width: 100%"></div>

      <!-- <div v-for="item of itemList">
        <div v-if="item.type === 'image'">
          <div><img :src="item.content" /></div>
        </div>
        <div v-if="item.type === 'text'">
          <div>{{ item.content }}</div>
        </div>
        <div v-if="item.type === 'audio'">
          <div><AudioBtn :urlId="item.content" /></div>
        </div>
        <Spacer height="12" />
      </div> -->
    </div>
    <div class="actions-wrapper">
      <button
      :style="safeBottomVar"
        class="lesson-approve"
        @click="finishLesson"
      >
        {{
          submitting
            ? $t("lesson.lesson-page.loading2")
            : $t("lesson.lesson-page.continue")
        }}
      </button>
    </div>
  </div>
</template>

<script>
import "./lesson-page.scss";
import LessonHeader from "./lesson-header.vue";
import Spacer from "../Shared/Spacer.vue";
import VideoPlayer from "../Shared/VideoPlayer.vue";
import AudioBtn from "../Shared/audioBtn.vue";
import AudioPlayerLesson from "../Shared/AudioPlayerLesson.vue";
import { userService } from "../../services/userService";
import { courseService } from "../../services/courseService";
import SlinkyVue from "../Shared/Slinky.vue";

export default {
  name: "lesson-page",
  props: ["data"],
  data() {
    return {
      lessonImage: null,
      lessonAudio: null,
      submitting: false,
      isAudio: 1
    };
  },
  created() {
    // const a = this.$store.getters.currentGame;
    // if (Object.keys(a).length === 0) {
    //   this.$router.push({
    //     path: `/`
    //   });
    // }
    // if (this.user) {
    //   userService.startLesson()
    // }
  },
  async mounted() {
    console.log(this.data);
    this.lessonImage = this.data.image;
    this.lessonAudio = this.data.audio;
    const lesson = await courseService.getLessonFromServer(this.data.id);
    console.log(lesson);
    this.lessonImage = lesson.image;
    this.lessonAudio = lesson.audio;
    if (this.data.audio) this.isAudio = 0;
  },
  computed: {
    currentGame() {
      if (this.$store.getters.currentGame) {
        return this.$store.getters.currentGame;
      }
    },
    user() {
      return this.$store.getters.user;
    },
    safeTopVar() {
      return { "--top": this.$store.getters.safeTop + "px" };
    },
    safeBottomVar() {
      return { "--bottom": this.$store.getters.safeBottom + "px" };
    }

    // itemList() {
    //   return this.$store.getters.currentGame.lesson.items.sort((a, b) => {
    //     return a.order > b.order ? 1 : -1;
    //   });
    // }
  },
  methods: {
    makeLinkEmbaddable: link => {
      if (String(link).includes("shorts")) {
        const youtubeID = String(link).split("/shorts/")[1];
        return (
          "https://www.youtube.com/embed/" +
          youtubeID +
          "?autoplay=" +
          this.isAudio +
          "&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0"
        );
      }
      if (String(link).includes(".be/")) {
        const youtubeID = String(link).split(".be/")[1];
        return (
          "https://www.youtube.com/embed/" +
          youtubeID +
          "?autoplay=" +
          this.isAudio +
          "&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0"
        );
      }
      const youtubeID = String(link).split("watch?v=")[1];
      return (
        "https://www.youtube.com/embed/" +
        youtubeID +
        "?autoplay=" +
        this.isAudio +
        "&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"
      );
    },
    async finishLesson() {
      this.submitting = true;
      if (this.data) {
        await userService.finishLesson(this.data.id, this.user);
      }
      this.submitting = false;
      // this.$router.push(`/lesson/${nextLesson.id}`);
      this.$router.push(`/chapter/`);
    }
  },
  components: {
    LessonHeader,
    Spacer,
    AudioBtn,
    VideoPlayer,
    AudioPlayerLesson,
    SlinkyVue
  }
};
</script>

<style scoped>
img {
  width: 90vw;
  max-width: 500px;
}

iframe {
  height: 50vh;
}
.lesson-approve {
  bottom: var(--bottom);
}
.LesonTop {
  position: sticky;
  top: var(--top);
}
.loader {
  text-align: center;
  margin: 30px;
}
</style>



// WEBPACK FOOTER //
// lesson-page.vue?307443e0